export default __webpack_public_path__ + "static/grand_hotel_1-843023ea579d027b6c38ee35c8b57edd.webp";